import { url } from "../Common/common";

async function postFormData(path, data) {
  const formData = new FormData();
  Object.entries(data || {}).forEach(([k, v]) => formData.append(k, v));

  const res = await fetch(`${url}${path}`, {
    method: "POST",
    body: formData,
  });
  return res.json();
}

export function getAnnouncements(pars, callback) {
  postFormData("/getannouncements", {
    filters: pars.filters || [],
    user_id: pars.user_id,
  }).then((data) => callback?.(data));
}

export function getCities(pars, callback) {
  postFormData("/getcities", {
    filters: pars.filters || [],
  }).then((data) => callback?.(data));
}

export function createAnnouncement(pars, callback) {
  postFormData("/createannouncement", pars).then((data) => callback?.(data));
}

export function createPay(pars, callback) {
  postFormData("/createpay", pars).then((data) => callback?.(data));
}

export function saveAnnouncement(pars, callback) {
  postFormData("/saveannouncement", pars).then((data) => callback?.(data));
}

export function deleteAnnouncement(pars, callback) {
  postFormData("/deleteannouncement", pars).then((data) => callback?.(data));
}


